import { Cloneable } from 'models/Utils/Cloneable';
import { ListingModel } from 'models/Listing/Listing';
import { RawItemSuggestedListing } from './types';

export class ItemSuggestedListingModel extends Cloneable {
  listingId: string;
  score: number;
  rank: number;
  listing: ListingModel;

  constructor(raw: RawItemSuggestedListing) {
    super();
    this.listingId = raw.listing_id;
    this.score = raw.score;
    this.rank = raw.rank;
    this.listing = new ListingModel(raw.listing);
  }
}
